import { render } from "./UpdateTeamNameForm.vue?vue&type=template&id=18c0ac4a"
import script from "./UpdateTeamNameForm.vue?vue&type=script&lang=js"
export * from "./UpdateTeamNameForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__